import React, { ReactNode } from "react";

import { Container } from "./styles";

interface IProps {
  icon: ReactNode;
  title: string;
  small?: boolean;
  onClick?: () => void;
  criare?: boolean;
  italinea?: boolean;
  todeschini?: boolean;
  selected?: boolean;
  disableOnFocus?: boolean;
  error?: boolean;
  img?: boolean;
}

const Button: React.FC<IProps> = ({
  icon,
  title,
  small = false,
  onClick: onClickCb,
  criare,
  italinea,
  selected,
  disableOnFocus,
  todeschini,
  error,
  img,
}) => {
  return (
    <Container
      small={small}
      onClick={onClickCb}
      criare={criare}
      italinea={italinea}
      selected={selected}
      disableOnFocus={disableOnFocus}
      todeschini={todeschini}
    >
      {icon}
      {!img && <span>{title}</span>}
    </Container>
  );
};

export default Button;
